import React from 'react'
import Routers from './Routers'

const index = () => {
  return (
    <div><Routers/></div>
  )
}

export default index